/**
 * 収集運搬・処分業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/traders`

const search_trader = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 収集運搬・処分業者一覧の取得.
     * ドロップダウンで表示可能な内容を返します.
     * @param commit
     * @param { string } search_type 加入区分 (all: すべて, transport: 収運, disposal: 処分)
     * @param { string|null } name
     * @param { boolean } without_invisible 非表示を除く()
     * @param { boolean } exclude_me 自社 収運を除く()
     * @param { boolean } only_location_registered
     * @param { boolean } self_emission
     * @param { boolean } include_proxy_entry 他社区間代行起票利用業者を含む
     * @param { boolean } include_general_waste_disposer 一般廃棄物処分業者を含む
     * @return {Promise<unknown>}
     */
    index ({ commit }, {
      search_type,
      name,
      without_invisible,
      exclude_me,
      only_location_registered,
      self_emission,
      include_proxy_entry,
      include_general_waste_disposer = false
      
    }) {
      const params = {
        search_type: search_type,
        name: name,
        without_invisible: without_invisible,
        exclude_me: exclude_me,
        only_location_registered: only_location_registered,
        self_emission: self_emission,
        include_proxy_entry: include_proxy_entry,
        include_general_waste_disposer: include_general_waste_disposer
      }
      return new Promise((resolve) => {　
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 収集運搬・処分業者情報の取得.
     * @param commit
     * @param { Number } id 収集運搬・処分業者のID
     * @return {Promise<unknown>}
     */
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_trader
